import { css } from '@emotion/react';

import { rem } from '../utilities/style';
import { colors } from '../theme/colors';
import { fontWeights } from '../theme/type';
import { media } from '../theme/media';

// eslint-disable-next-line import/prefer-default-export
export const buttonStyles = ({ light, theme, size }) => css`
  label: primary;
  border: none;
  position: relative;
  text-align: center;
  z-index: 0;
  display: inline-flex;
  align-items: center;
  border-radius: ${rem(40)};
  font-weight: ${fontWeights.semiBold};
  font-size: ${rem(16)};
  line-height: 1.2;
  overflow: hidden;
  cursor: pointer;
  padding: ${rem(16)} ${rem(24)};

  ${size === 'small' && `
    padding: ${rem(12)} ${rem(18)};
  `}

  ${size === 'large' && `
    padding: ${rem(16)} ${rem(24)};
    font-size: ${rem(18)};

    ${media('>mini')} {
      padding: ${rem(20)} ${rem(32)};
      font-size: ${rem(20)};
    }
  `}

  background: ${light ? colors.white : colors.blue['500']};
  color: ${light ? colors.blue['800'] : colors.gray['50']};
  ${theme.pageOverrides?.includes('Green Buttons') && `
    background: ${light ? colors.white : colors.green['500']};
    color: ${light ? colors.green['800'] : colors.gray['50']};
  `}

  ${light && `
    transition: all .2s ease .1s;
  `}

  &:focus,
  &:hover {
    ${light && `
      color: ${colors.white};
    `}

    &::before {
      transform-origin: left;
      transform: scale(1.1);

      ${light && `
        opacity: 1;
      `}
    }
  }

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    inset: -1px;
    border-radius: inherit;
    background: ${theme.pageOverrides?.includes('Green Buttons') ? colors.green['700'] : colors.blue['800']};
    transform-origin: right;
    transform: scaleX(0);
    transition: transform .2s ease;
  }
`;
